import React from "react";
import {
  View,
  Grid,
  Card,
  useTheme,
  Link,
  Icon,
  Heading,
  Text
} from "@aws-amplify/ui-react";

import "./Dashboard.css";

import { Amplify } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';

import awsExports from 'src/aws-exports';
import { useNavigate } from "react-router-dom";
import { MdArrowRight, MdArrowRightAlt, MdOutlineArrowRight } from "react-icons/md";
import { BsArrowRightCircleFill, BsArrowRightSquareFill } from "react-icons/bs";
Amplify.configure(awsExports);

const Dashboard = () => {
  const { tokens } = useTheme();
  const navigate = useNavigate();
  return (
    <>
      <View borderRadius="6px" maxWidth="100%" padding="0rem" minHeight="100vh">
        <Grid
          templateColumns={{ base: "1fr", large: "1fr 1fr 1fr" }}
          gap={tokens.space.xl}
        >
          <View rowSpan={{ base: 1, large: 1 }}>
            <Card
              variation="elevated"
              borderRadius="15px"
              display="flex"
              style={{'flexDirection': 'row', 'justifyContent': 'space-between'}}
              height="100%"
            >
              <div>
                <Heading level={3}>Task</Heading>
                <Text>Visualizza e gestisci i tuoi task</Text>
              </div>
              <Link onClick={() => navigate('/task')} style={{ alignSelf: 'flex-end' }}  marginBottom="-10px" fontSize="28px">
                <Icon textAlign="right" as={BsArrowRightCircleFill} />
              </Link>
            </Card>
          </View>
          <View rowSpan={{ base: 1, large: 1 }}>
            <Card
              variation="elevated"
              borderRadius="15px"
              display="flex"
              style={{'flexDirection': 'row', 'justifyContent': 'space-between'}}
              height="100%"
            >
              <div>
                <Heading level={3}>Bozze inserite</Heading>
                <Text>Visualizza e gestisci le bozze degli operatori sanitari inseriti</Text>
              </div>
              <Link onClick={() => navigate('/os/bozze')} style={{ alignSelf: 'flex-end' }} marginBottom="-10px" fontSize="28px">
                <Icon textAlign="right" as={BsArrowRightCircleFill} />
              </Link>
            </Card>
          </View>
        </Grid>
      </View>
    </>
  );
};

export default Dashboard;
